<!--
 * @Author: your name
 * @Date: 2020-08-26 15:52:23
 * @LastEditTime: 2021-02-22 16:36:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Kares\src\components\system\OperationLog.vue
-->
<template>
  <div class="operation-log">
    <enfold>
      <enfold-cd>
        <template slot="center">
          <el-table :data="logList" style="width: 100%" height="100%" v-loading="loading">
            <el-table-column prop="user_name" :label="$t('cso1')" width="120"></el-table-column>
            <el-table-column :label="$t('cso2')">
              <template slot-scope="scope">{{`${scope.row.module}/${scope.row.controller}/${scope.row.action}`}}</template>
            </el-table-column>
            <el-table-column prop="title" :label="$t('cso3')"></el-table-column>
            <el-table-column prop="create_time" :label="$t('cso4')" width="180"></el-table-column>
          </el-table>
        </template>
        <template slot="down">
          <pagination :current="current" :limit="limit" @currentChange="currentChange"></pagination>
        </template>
      </enfold-cd>
    </enfold>
  </div>
</template>

<script>
import enfold from '@/components/basics/Enfold'
import EnfoldCd from '@/components/basics/EnfoldCD'
import pagination from '@/components/basics/Pagination'
import { mPagination } from "@/components/basics/mixins";
export default {
  name: "OperationLog",
  mixins: [mPagination],
  data() {
    return {
      logList: [],
      loading: true,
    }
  },
  created() {
    this.getLogList({ limit: this.limit, page: 1 });
  },
  methods: {
    getLogList(log) {
      this.$http.post("/admin/log/list", log, data => {
        this.logList = data.list;
        this.current = parseInt(data.count);
        this.loading = false;
      });
    },
    currentChange(val) {
      this.getLogList({ limit: this.limit, page: val });
    }
  },
  components: {
    enfold,
    pagination,
    EnfoldCd
  },
  computed: {

  }
}
</script>

<style lang="scss" scoped>
.operation-log {
  width: 100%;
  height: 100%;
  /deep/ .cell {
    font-size: 16px;
  }
  /deep/ .el-table__header-wrapper {
    .cell {
      font-size: 18px;
      color: var(--theme-color-customized-1);
    }
  }
}
</style>